import BaseQuery from "../BaseQuery";

export default class HandleCallbackQuery extends BaseQuery {
  
    public code: string;
    public tenantName: string;

    constructor(code: string, tenantName: string) {
        super();
        this.code = code;
        this.tenantName = tenantName;
    }

    public override isPost(): boolean {
        return true;
    }

    public ConstructQueryString(): void {
        // Not needed for POST request
    }

    public GetEndpoint(): string {
        return `genesys/authenticate`;
    }

    public override getRequestBody() {
        return { 
            code: this.code,
            tenantName: this.tenantName 
        };
    }
}
